import { useLayoutEffect } from 'react'

function useOutsideClick(
  element: Element | null,
  callback: () => void,
  container?: Element | null
) {
  useLayoutEffect(() => {
    function handleClick(event: MouseEvent) {
      if (element && !element.contains(event.target as Node)) {
        if (container && !container.contains(event.target as Node)) return
        callback()
      }
    }
    document.addEventListener('click', handleClick)
    return () => document.removeEventListener('click', handleClick)
  }, [element, callback, container])
  return true
}
export default useOutsideClick
